<template>
  <div class="layout w-100">
    <header>
      <slot name="header"></slot>
    </header>
    <div class="subheader">
      <slot name="subheader"></slot>
    </div>
    <main>
      <slot></slot>
    </main>
    <cms-navigation v-if="navigation"></cms-navigation>
  </div>
</template>

<script>
import navigation from "../cms-navigation";

export default {
  name: "cms-layout",
  components: {
    "cms-navigation": navigation
  },
  props: {
    navigation: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped lang="scss">
.layout {
  position: absolute;
  display: flex;
  flex-direction: column;
  height: 100%;
}

header {
  height: 50px;
  background-color: $bluish80-color;
  color: white;
}

main {
  flex: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: scroll;
  width: 100%;
}

.btn {
  &.btn-primary {
    border-radius: 5px;
    letter-spacing: 0.5px;
    background-color: $bluish-two-color;
    border: none;
    color: $white-five-color;
  }
}
</style>
